module.exports = __webpack_public_path__ + "static/media/hotel2.bcafb64c.jpg";